module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_sns_03-d064631b25f477ae26d346b9011347c8.jpg";